import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'extraerNombreDoc'
})
export class ExtraerNombreDocPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';
    const parts = value.split('/');
    const fileName = parts[parts.length - 1];
    return `${fileName}`;
  }

}
